import _regeneratorRuntime from 'babel-runtime/regenerator';
import _extends from 'babel-runtime/helpers/extends';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _Set from 'babel-runtime/core-js/set';

import { getCreativeReportList } from '@/api/creative/report';
import { format } from 'date-fns';
import _ from 'lodash';

export default {
  data: function data() {
    return {
      selectDate: '',
      loading: false,
      filterArray: [{
        label: '拒审数',
        value: 'reject_count'
      }, {
        label: '拒审率',
        value: 'reject_rate'
      }, {
        label: '涉黄数',
        value: 'porn_count'
      }, {
        label: '涉黄率',
        value: 'porn_rate'
      }, {
        label: '涉政数',
        value: 'political_count'
      }, {
        label: '涉政率',
        value: 'political_rate'
      }],
      formValue: {
        time: [],
        reject_count_min: '',
        reject_count_max: '',
        reject_rate_min: '',
        reject_rate_max: '',
        porn_count_min: '',
        porn_count_max: '',
        porn_rate_min: '',
        porn_rate_max: '',
        political_count_min: '',
        political_count_max: '',
        political_rate_min: '',
        political_rate_max: '',
        reject_count_or: '',
        reject_rate_or: '',
        porn_count_or: '',
        porn_rate_or: '',
        political_count_or: '',
        political_rate_or: '',
        group_by: 'adv_name'
      },
      filterGroup: []
    };
  },

  computed: {
    filterConditions: function filterConditions() {
      var _this = this;

      var labelList = [];

      this.filterGroup.map(function (t) {
        var value = '';
        _this.repeatLabel = [];
        if (t.value && (t.min || t.max)) {
          if (t.min) {
            value = t.min + '\u2264' + value;
          }
          value += t.label;
          if (t.max) {
            value = value + ('\u2264' + t.max);
          }
          labelList.push(value);
        }
      });
      return labelList && labelList.join(',').replace(/,/g, ' or ');
    },
    pickerOptions: function pickerOptions() {
      var self = this;
      return {
        disabledDate: function disabledDate(time) {
          if (time.getTime() > Date.now()) return true;
          if (self.selectDate) {
            var days = 180 * 24 * 3600 * 1000;
            return time.getTime() < self.selectDate || time.getTime() > self.selectDate + days;
          }
          return false;
        },

        onPick: function onPick(_ref) {
          var maxDate = _ref.maxDate,
              minDate = _ref.minDate;

          self.selectDate = minDate.getTime();
          if (maxDate) {
            self.selectDate = '';
          }
        }
      };
    }
  },
  methods: {
    getUnit: function getUnit(val) {
      return val && val.indexOf('count') !== -1 ? '个' : '%';
    },
    getMax: function getMax(val) {
      return val && val.indexOf('count') !== -1 ? Infinity : 100;
    },
    handleBlur: function handleBlur() {
      this.selectDate = '';
    },
    handleDeleteFilter: function handleDeleteFilter(val, index) {
      this.formValue[val + '_or'] = '';
      this.formValue[val + '_min'] = '';
      this.formValue[val + '_max'] = '';
      this.filterGroup.splice(index, 1);
    },
    handleAddFilter: function handleAddFilter() {
      this.filterGroup.push({
        min: 0,
        max: 0,
        value: '',
        label: '',
        filterArray: this.filterArray
      });
    },
    handleChange: function handleChange(item) {
      item.label = item.filterArray.find(function (s) {
        return s.value === item.value;
      }).label;
    },
    handleReset: function handleReset() {
      var _this2 = this;

      this.filterGroup.map(function (t) {
        if (t.value) {
          _this2.formValue[t.value + '_or'] = '';
          _this2.formValue[t.value + '_min'] = '';
          _this2.formValue[t.value + '_max'] = '';
        }
      });
      this.filterGroup = [];
    },
    handleAddSubmit: function handleAddSubmit() {
      var _this3 = this;

      this.$refs['filter-form'].validate(function (valid) {
        if (valid) {
          var duplicateItems = [];
          var repeatLabel = [];

          _this3.filterGroup.map(function (t) {
            if (t.value && (t.min || t.max)) {
              duplicateItems.push(t.label);
              _this3.formValue[t.value + '_or'] = 1;
              if (t.min) {
                _this3.formValue[t.value + '_min'] = t.value.indexOf('count') !== -1 ? t.min : Number(t.min / 100);
              }

              if (t.max) {
                _this3.formValue[t.value + '_max'] = t.value.indexOf('count') !== -1 ? t.max : Number(t.max / 100);
              }
            }
          });
          // 过滤重复的筛选条件
          if (duplicateItems.length) {
            var set = new _Set();
            duplicateItems.forEach(function (item) {
              if (set.has(item)) {
                repeatLabel.push(item);
              } else {
                set.add(item);
              }
            });
          }

          if (repeatLabel.length) {
            _this3.$message.error(repeatLabel.join(',') + '\u7B5B\u9009\u6761\u4EF6\u91CD\u590D, \u8BF7\u91CD\u65B0\u7B5B\u9009');
            return;
          }
          _this3.submit();
        }
      });
    },
    submit: function submit() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var params, res, filterAdvNameArray;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this4.loading = true;

                params = _extends({}, _this4.formValue, {
                  start_time: _this4.formValue.time && format(_this4.formValue.time[0], 'YYYY-MM-DD'),
                  end_time: _this4.formValue.time && format(_this4.formValue.time[1], 'YYYY-MM-DD')
                });

                delete params.time;

                _context.prev = 3;
                _context.next = 6;
                return getCreativeReportList(params);

              case 6:
                res = _context.sent;
                filterAdvNameArray = (_.get(res, 'data.data.list') || []).map(function (item) {
                  return item.adv_name;
                }) || [];

                _this4.$emit('getAdvName', filterAdvNameArray);

                _this4.loading = false;
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](3);

                _this4.loading = false;

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4, [[3, 12]]);
      }))();
    }
  }
};